import { render, staticRenderFns } from "./ArticleDetailContent.vue?vue&type=template&id=38625c4b&scoped=true&"
import script from "./ArticleDetailContent.vue?vue&type=script&lang=js&"
export * from "./ArticleDetailContent.vue?vue&type=script&lang=js&"
import style0 from "./ArticleDetailContent.vue?vue&type=style&index=0&id=38625c4b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38625c4b",
  null
  
)

export default component.exports